// Friendly alphabet — uppercase alphanumeric without visually confusable
// characters (no 0/O, no 1/I/L). 31 chars, so a 6-char code yields
// 31^6 ≈ 887M combinations; collisions are rare and caught by the
// session-creation Lambda with a few retries.
const ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
export const SESSION_CODE_LENGTH = 6;
export function generateSessionCode() {
    const bytes = new Uint8Array(SESSION_CODE_LENGTH);
    // crypto is a globalThis property in Node 20+ and all modern browsers.
    globalThis.crypto.getRandomValues(bytes);
    let out = "";
    for (let i = 0; i < bytes.length; i++) {
        out += ALPHABET[bytes[i] % ALPHABET.length];
    }
    return out;
}
/**
 * What a session-code box keeps of what was typed or pasted: upper-cased,
 * only characters a code can contain, cut to the code length. Every code
 * input uses this, so they all accept the same characters.
 */
export function cleanSessionCodeInput(raw) {
    let out = "";
    for (const ch of raw.toUpperCase()) {
        if (out.length === SESSION_CODE_LENGTH)
            break;
        if (ALPHABET.includes(ch))
            out += ch;
    }
    return out;
}
export function isValidSessionCode(code) {
    if (code.length !== SESSION_CODE_LENGTH)
        return false;
    for (let i = 0; i < code.length; i++) {
        if (!ALPHABET.includes(code[i]))
            return false;
    }
    return true;
}
//# sourceMappingURL=sessionCode.js.map